import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { UzurvDirectivesModule } from '@uzurv/core';
import { MaterialModule} from '../../app/material.module';
import { RequiresPermissionsModule } from '../directives';
import { InlineEditComponentModule } from '../inline-edit/inline-edit.module';
import { TripFareAdjustmentDetailComponent } from './trip-fare-adjustment-detail.component';

@NgModule({
  declarations: [TripFareAdjustmentDetailComponent],
  imports: [
    CommonModule,
    RequiresPermissionsModule,
    UzurvDirectivesModule,
    MaterialModule,
    InlineEditComponentModule,
    FormsModule
  ],
  exports: [TripFareAdjustmentDetailComponent]
})
export class TripFareAdjustmentDetailModule {}
